import { gql } from '@apollo/client';

export const surfaceNodeEjectedFromProtocolSubscription = gql`
  subscription surfaceNodeEjectedFromProtocol($surface: ID!, $user: ID!) {
    surfaceNodeEjectedFromProtocol(surface: $surface, user: $user) {
      id
    }
  }
`;
